import {IFetchContext} from "@pg-mono/data-fetcher";
import {pick} from "@pg-mono/nodash";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {MetaDataDispatch, updateMetaData} from "../../../meta_data/actions/update_meta_data";
import {descriptionOfferList} from "../../../meta_data/page_description/offer_list";
import {titleOfferList} from "../../../meta_data/page_title/offer_list";
import {IRegion} from "../../../region/fetch_region_path";
import {IRootState} from "../../../store/store";
import {getThumbnailLink} from "../../../utils/get_thumbnail_link";
import {getOfferTypeUrl} from "../../helpers/OfferType";
import {ISelectedRegion} from "../../list/actions/offer_list_selected_data_actions";

export const updateOfferMultiListMapMetaData = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: MetaDataDispatch, getState: () => IRootState) => {
    const {selectedRegions} = getState().offerList;
    const regions = selectedRegions.length > 0 ? (selectedRegions as ISelectedRegion[]) : undefined;
    const {propertiesCount, latestQuery} = getState().offerListMap.list;
    const {offers, privileged_offers} = getState().offerList.list;
    const type = parseInt(latestQuery["type"] as string, 10);

    const firstOffer =
        privileged_offers.find((offer) => offer.main_image_url || offer.main_image?.m_img_750) ||
        offers.find((offer) => offer.main_image_url || offer.main_image?.m_img_750);
    const ogImage = getThumbnailLink(firstOffer?.main_image_url, 750) ?? firstOffer?.main_image?.m_img_750 ?? undefined;

    const filtersData = pick(latestQuery, ["construction_end_date", "is_luxury", "price_lower_than_average"]);

    const title = titleOfferList(
        {
            regionName: regions && `${regions.map((r) => `\n - ${r.full_name_reverted}`).join(" ")}`,
            type,
            regions
        },
        undefined,
        {
            construction_end_date: filtersData.construction_end_date as string,
            is_luxury: Boolean(filtersData.is_luxury),
            price_lower_than_average: Boolean(filtersData.price_lower_than_average)
        }
    );

    const fullQuery = {
        region: regions && (regions[0] as IRegion),
        propertiesCount: propertiesCount ?? 0,
        is_luxury: Boolean(latestQuery.is_luxury),
        price_lower_than_average: Boolean(latestQuery.price_lower_than_average),
        sort: latestQuery.sort as string,
        offerType: isFinite(type) ? type : undefined,
        type: isFinite(type) ? type : undefined,
        construction_end_date: latestQuery.construction_end_date as string
    };

    const description = descriptionOfferList(fullQuery);

    const robots = "noindex, follow";
    const customCanonicalPath = `/s/${getOfferTypeUrl(type)}-${regions && regions[0].slug}/`;
    dispatch(updateMetaData({title, description, pathname: ctx.route.pathname, robots, customCanonicalPath, ogImage}));
    return true;
};
import {IFetchContext} from "@pg-mono/data-fetcher";
import {pick} from "@pg-mono/nodash";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {MetaDataDispatch, updateMetaData} from "../../../meta_data/actions/update_meta_data";
import {descriptionOfferList} from "../../../meta_data/page_description/offer_list";
import {titleOfferList} from "../../../meta_data/page_title/offer_list";
import {IRegion} from "../../../region/fetch_region_path";
import {IRootState} from "../../../store/store";
import {getThumbnailLink} from "../../../utils/get_thumbnail_link";
import {getOfferTypeUrl} from "../../helpers/OfferType";
import {ISelectedRegion} from "../../list/actions/offer_list_selected_data_actions";

export const updateOfferMultiListMapMetaData = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: MetaDataDispatch, getState: () => IRootState) => {
    const {selectedRegions} = getState().offerList;
    const regions = selectedRegions.length > 0 ? (selectedRegions as ISelectedRegion[]) : undefined;
    const {propertiesCount, latestQuery} = getState().offerListMap.list;
    const {offers, privileged_offers} = getState().offerList.list;
    const type = parseInt(latestQuery["type"] as string, 10);

    const firstOffer =
        privileged_offers.find((offer) => offer.main_image_url || offer.main_image?.m_img_750) ||
        offers.find((offer) => offer.main_image_url || offer.main_image?.m_img_750);
    const ogImage = getThumbnailLink(firstOffer?.main_image_url, 750) ?? firstOffer?.main_image?.m_img_750 ?? undefined;

    const filtersData = pick(latestQuery, ["construction_end_date", "is_luxury", "price_lower_than_average"]);

    const title = titleOfferList(
        {
            regionName: regions && `${regions.map((r) => `\n - ${r.full_name_reverted}`).join(" ")}`,
            type,
            regions
        },
        undefined,
        {
            construction_end_date: filtersData.construction_end_date as string,
            is_luxury: Boolean(filtersData.is_luxury),
            price_lower_than_average: Boolean(filtersData.price_lower_than_average)
        }
    );

    const fullQuery = {
        region: regions && (regions[0] as IRegion),
        propertiesCount: propertiesCount ?? 0,
        is_luxury: Boolean(latestQuery.is_luxury),
        price_lower_than_average: Boolean(latestQuery.price_lower_than_average),
        sort: latestQuery.sort as string,
        offerType: isFinite(type) ? type : undefined,
        type: isFinite(type) ? type : undefined,
        construction_end_date: latestQuery.construction_end_date as string
    };

    const description = descriptionOfferList(fullQuery);

    const robots = "noindex, follow";
    const customCanonicalPath = `/s/${getOfferTypeUrl(type)}-${regions && regions[0].slug}/`;
    dispatch(updateMetaData({title, description, pathname: ctx.route.pathname, robots, customCanonicalPath, ogImage}));
    return true;
};
